import type { InterventionSectionEmptyProps } from "./intervention-section-empty.type";

import { Empty } from "antd";
import { useTranslation } from "react-i18next";

const InterventionSectionEmpty = ({ type }: InterventionSectionEmptyProps) => {
  const { t } = useTranslation();

  return (
    <Empty
      description={
        <>
          {t(`intervention:sectionEmpty.description.${type}`)}
          <br />
          {t("intervention:sectionEmpty.checkTemplate")}
        </>
      }
    />
  );
};

export default InterventionSectionEmpty;
